<template>
  <querytable ref="table" :data="data" @row-click="onRowClick" current-row-mode
    @current-row-change="handleCurrentRowChange" size="small">
    <slot></slot>
  </querytable>
</template>
<script setup lang="ts">
import { ref, useTemplateRef, watch } from 'vue'
import Querytable from '../Querytable'
import { useLov } from '../Input'
import { findIndex } from 'lodash-es'

defineOptions({ name: 'OLovQuerytable', inheritAttrs: true })

const { data } = defineProps<{ data: any[] }>()
const tableRef = useTemplateRef('table')
const currentRowIndex = ref()
const currentRowData = ref()

const lov = useLov()
lov?.registerKeydownHandler((code) => {
  if (code == 'ArrowUp') {
    let nextRow: any
    if (currentRowIndex.value == 0) {
      nextRow = data[data.length - 1]
    } else {
      nextRow = data[currentRowIndex.value - 1]
    }
    //@ts-ignore
    tableRef.value!.setCurrentRow(nextRow)
    scrollToRow(currentRowIndex.value)
  } else if (code == 'ArrowDown') {
    let nextRow: any
    if (currentRowIndex.value == data.length - 1) {
      nextRow = data[0]
    } else {
      nextRow = data[currentRowIndex.value + 1]
    }
    //@ts-ignore
    tableRef.value!.setCurrentRow(nextRow)
    scrollToRow(currentRowIndex.value)
  } else if (code == 'Enter') {
    currentRowData.value && lov?.backfill(currentRowData.value)
  }
})

const scrollToRow = (index: number) => {
  const $table = tableRef.value!.$el
  const $row = $table.querySelectorAll('.el-table__row')[index]
  $row.scrollIntoViewIfNeeded()
}

const onRowClick = (row: any) => {
  lov?.backfill(row)
}

const handleCurrentRowChange = (row: any) => {
  const index = findIndex(data, row)
  if (index == -1) {
    currentRowIndex.value = 0
    currentRowData.value = data[0]
  } else {
    currentRowIndex.value = index
    currentRowData.value = row
  }
}

watch(
  () => data,
  () => {
    if (data.length > 0) {
      //@ts-ignore
      tableRef.value!.setCurrentRow(data[0])
    }
  }
)
</script>
